<npt-page-layout>
    <ng-template nptTemplate="headerCenter">
        <app-wallet></app-wallet>
    </ng-template>
</npt-page-layout>